import React from 'react'
import Modal from 'react-bootstrap/Modal';

const ConfirmBox = ({show, handleClose, message, title , handleSubmit, deleteBtn=true}) => {
    return(
        <>
        
        <Modal centered show={show} onHide={handleClose}>
          <Modal.Header className="popupheader delete pt-4">
            {title}
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group pt-4 pb-5 m-0">
                  <p className="popupheading delete p-0 m-0">{message}</p>
                </div>
                <div className="row">
                  <div className=" d-flex align-items-center justify-content-center mt-2 mb-2 footerbtn">
                    <button className="cancel" onClick={handleClose}>Cancel</button>
                    {deleteBtn ?
                    <button className="save" onClick={handleSubmit}>Delete</button>
                    :
                    <button className="save" onClick={handleSubmit} >Save</button>
                    }
                       {/* <button className="loading save">
                          <svg viewBox="25 25 50 50">
                            <circle r="20" cy="50" cx="50"></circle>
                          </svg>
                       </button> */}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        </>
    )
}

export default ConfirmBox